module.exports = __webpack_public_path__ + "img/btn_activity.b6e2ca4.webp";